import React from 'react';
import {extendTheme} from '@chakra-ui/react';
import {ChakraProvider} from '@chakra-ui/react';
import {options} from './options';

const theme = extendTheme(options);

const ChakraUiProvider = (props) => {
    return (
        <ChakraProvider resetCSS theme={theme}>
            {props.children}
        </ChakraProvider>
    );
};

export default ChakraUiProvider;
export {theme};
